/* NEW: UI_REVAMP */
import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import GradientText from '../../common/GradientText';
import { RECORD_GRADIENTS, RECORD_TEXT_COLORS } from '../../../styles/recordUiTokens';

const HistoryBetSectionHeader = ({ success, numOfList }) => {
	return (
		<Flex alignItems='center' gap='8px' marginTop={{ base: '18px', lg: '10px' }}>
			<Flex fontWeight='600' fontSize='16px'>
				{success ? (
					<GradientText>Successful Bet List</GradientText>
				) : (
					<GradientText gradient={RECORD_GRADIENTS.failedText}>Failed Bet List</GradientText>
				)}
			</Flex>

			<Text color={RECORD_TEXT_COLORS.muted} fontWeight='500' fontSize='14px'>
				{numOfList > 1 ? `${numOfList} bets` : `${numOfList} bet`}
			</Text>
		</Flex>
	);
};

export default HistoryBetSectionHeader;
